import { type AudienceKind } from "./audience";

export enum MediaDataRoomTab {
  data = "data",
  insights = "insights",
  activation = "activation",
  auditLog = "auditLog",
  configuration = "configuration",
}

export enum MediaDataRoomActivationTab {
  creation = "creation",
}

export const mediaDataRoomTabs = [
  MediaDataRoomTab.data,
  MediaDataRoomTab.insights,
  MediaDataRoomTab.activation,
  MediaDataRoomTab.auditLog,
  MediaDataRoomTab.configuration,
];

export type AudienceFilter = AudienceKind | "all";
